import { B2B_JANES } from 'constants/endpoints';
import { METHOD_GET } from 'requests';
import { devtoolsInNonProd } from 'store/zustand/index.utils';
import { createBookJaneRequest } from 'utils/createBookJaneRequest';
import { handleGenericErrorMessage } from 'utils/handleGenericErrorMessage';
import { create } from 'zustand';
import {
  JaneSkillAssignmentsData,
  JaneSkillAssignmentsResponse,
  JaneSkillAssignmentsState,
} from 'modals/JaneDetailsModal/views/EditJaneView/store/janeSkillAssignments.store.types';

const INITIAL_STATE: JaneSkillAssignmentsData = {
  assignments: [],
  isLoading: false,
};

let fetchId = 0;

export const janeSkillAssignmentsStore = create<JaneSkillAssignmentsState>()(
  devtoolsInNonProd((set) => ({
    ...INITIAL_STATE,

    fetchAssignments: (janeId) => {
      const currentFetchId = ++fetchId;
      set({ assignments: [], isLoading: true });

      createBookJaneRequest<JaneSkillAssignmentsResponse>({
        method: METHOD_GET,
        url: B2B_JANES(janeId),
      })
        .then(({ data }) => {
          if (currentFetchId !== fetchId) return;
          set({ assignments: data.jane.janes_skills ?? [], isLoading: false });
        })
        .catch((error) => {
          if (currentFetchId !== fetchId) return;
          handleGenericErrorMessage(error);
          set({ isLoading: false });
        });

      return () => {
        fetchId++;
      };
    },

    reset: () => set(INITIAL_STATE),
  })),
);

export const useJaneSkillAssignmentsStore = janeSkillAssignmentsStore;
